import React from "react";
import './PicnicMarker.css'
import { Link } from "react-router-dom";
import { getSeoUrl } from "../utils";
import { Box } from "native-base";

const markerImg = require('../img/picnic_logo_circle-cropped.png');

const markerStyle = {
  marginTop: '-50px',
  width: "fit-content"
}

const imgStyle = {
  cursor: 'pointer',
  position: 'relative',
  zIndex: 10,
}


const PicnicMarker = ({ data, onClusterClick }) => {
 const { properties } = data; 
  if (properties.cluster)
  {
    return (
      <div style={markerStyle} onClick={()=> onClusterClick(data)}>
        <img style={imgStyle} src={markerImg} alt={properties.cluster_id} height="60px" width="60px" />
        <h3 className="marker-cluster">{properties.point_count}</h3>
      </div>
    )
  }
  const detailUrl = `/detail/${getSeoUrl(properties.data.nombre)}-${properties.data.id}`;
  return (
    <Link to={detailUrl} style={{textDecoration: "none"}}>
        <div style={markerStyle}>
          <img style={imgStyle} src={markerImg} alt={properties.nombre} height="60px" width="60px" />
          <Box className="marker-box">
            <h3 className="marker-text">{properties.nombre}</h3>
          </Box>
        </div>
      </Link>
  );
};

export default PicnicMarker;